import { render, staticRenderFns } from "./BxAssetsTable.vue?vue&type=template&id=0400133b&scoped=true&"
import script from "./BxAssetsTable.vue?vue&type=script&lang=js&"
export * from "./BxAssetsTable.vue?vue&type=script&lang=js&"
import style0 from "./BxAssetsTable.vue?vue&type=style&index=0&id=0400133b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0400133b",
  null
  
)

export default component.exports